var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2929 9.29289L14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289C16.0676 7.65338 16.0953 8.22061 15.7903 8.6129L15.7071 8.70711L15.3892 9.02302C15.5916 9.00771 15.7953 9 16 9C20.4183 9 24 12.5817 24 17C24 21.4183 20.4183 25 16 25C11.5817 25 8 21.4183 8 17C8 16.4477 8.44772 16 9 16C9.55228 16 10 16.4477 10 17C10 20.3137 12.6863 23 16 23C19.3137 23 22 20.3137 22 17C22 13.6863 19.3137 11 16 11C15.8129 11 15.6271 11.0085 15.4429 11.0254L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071C15.3466 13.0676 14.7794 13.0953 14.3871 12.7903L14.2929 12.7071L12.2929 10.7071C11.9324 10.3466 11.9047 9.77939 12.2097 9.3871L12.2929 9.29289L14.2929 7.29289L12.2929 9.29289Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshScan);
export default __webpack_public_path__ + "static/media/refresh-scan.0c772264164285b6c4a4e73d39e70777.svg";
export { ForwardRef as ReactComponent };